<script setup lang="ts">
const { locale } = useI18n();
const slug = useRoute().params.slug as string;
const stemPrefix = locale.value === "fr" ? "blog/" : `${locale.value}/blog/`;
const { data: blog } = await useAsyncData(`blog-${locale.value}-${slug}`, () =>
  queryCollection("blog").where("stem", "=", stemPrefix + slug).first(),
);

if (!blog?.value) {
  throw createError({
    statusCode: 404,
    message: "Page introuvable",
  });
}

if (blog.value.seo)
  useSeoMeta({
    title: blog.value.seo.title,
    description: blog.value.seo.description,
  });

useSchemaOrg([defineArticle()]);
</script>

<template>
  <main class="relative">
    <div
      class="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
      aria-hidden="true"
    >
      <div
        class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-blue-300 to-primary-300 opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
        style="
          clip-path: polygon(
            74.1% 44.1%,
            100% 61.6%,
            97.5% 26.9%,
            85.5% 0.1%,
            80.7% 2%,
            72.5% 32.5%,
            60.2% 62.4%,
            52.4% 68.1%,
            47.5% 58.3%,
            45.2% 34.5%,
            27.5% 76.7%,
            0.1% 64.9%,
            17.9% 100%,
            27.6% 76.8%,
            76.1% 97.7%,
            74.1% 44.1%
          );
        "
      />
    </div>

    <div class="relative isolate -mb-24 overflow-hidden">
      <div class="mx-auto max-w-7xl px-6 pt-10 lg:flex lg:px-8 lg:pt-40">
        <ContentRenderer
          v-if="blog"
          class="prose mx-auto max-w-2xl prose-h1:mt-20 prose-h1:font-serif prose-a:prose-headings:no-underline prose-h1:sm:mt-12"
          :value="blog"
        />
      </div>
    </div>

    <LandingEndCta />
  </main>
</template>
